import React, { Component, Fragment } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import qs from 'query-string';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import autzuWhiteBack from '../../../images/autzuWhiteBack.png';
import appleIcon from '../../../images/applestore.svg';
import googleIcon from '../../../images/googleplay.svg';

import ScrollLock from 'react-scrolllock';

import './landingPage.css';

class MobileLandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  readStepValues = () => {
    const values = qs.parse(this.props.location.search);

    if (values.type) {
      return this.redirectionTypes(values.type);
    }
  };

  redirectionTypes = type => {
    switch (type) {
      case 'login':
        return 'To login to your account, please download our mobile app.';
      case 'signup':
        return 'Please login into our mobile app to continue your Application.';
      case 'link':
        return 'To view this link, please login to our mobile app.';
      default:
        return null;
    }
  };

  isVisible = page =>
    !this.isMobile
      ? this.state.currentPage === page || this.state.loaded[page]
      : true;

  isMobile = window.innerWidth < 768;

  render() {
    const { history, country } = this.props;
    console.log(history);
    console.log(country);
    return (
      <Fragment>
        <div className="close-icon">
          <FontAwesomeIcon
            icon={faTimes}
            size="2x"
            onClick={() => {
              this.props.history.goBack();
            }}
          />
        </div>

        <div className="mobile-landing-page">
          <div className="mobile-logo">
            <img
              className={
                window.innerWidth > 768
                  ? 'mobile-logo-image__desktop'
                  : 'mobile-logo-image'
              }
              src={autzuWhiteBack}
              alt="Autzu Logo"
            />
          </div>

          {this.readStepValues() ? (
            <div className="mobile-description">
              {this.readStepValues()}
            </div>
          ) : (
            <div className="mobile-description">
              To signup or login to your account, please download our
              mobile app.
            </div>
          )}

          <div className="link-instructions">
            Click on your App Store to download the app.
          </div>
          <div className="app-link-container">
            <a
              href={
                country === 'CA'
                  ? 'https://apps.apple.com/ca/app/autzu/id1486349150?mt=8'
                  : 'https://apps.apple.com/us/app/autzu/id1486349150?mt=8'
              }
              className="apple-store-link"
              target="_blank">
              <img src={appleIcon} />
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.autzu.autzuAndroid&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
              className="play-store-link"
              target="_blank">
              <img alt="Get it on Google Play" src={googleIcon} />
            </a>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(MobileLandingPage);



// WEBPACK FOOTER //
// ./src/components/Static/LandingPage/MobileLandingPage.js